import { Outlet } from "react-router-dom";
import MainNavigation from "../components/Navigation/MainNavigation";

const RootLayout = () => {
  return <Outlet />;
};

export default RootLayout;
